import { render, staticRenderFns } from "./variant-form.vue?vue&type=template&id=9c1296c0&scoped=true&"
import script from "./variant-form.vue?vue&type=script&lang=js&"
export * from "./variant-form.vue?vue&type=script&lang=js&"
import style0 from "./variant-form.vue?vue&type=style&index=0&id=9c1296c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1296c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9c1296c0', component.options)
    } else {
      api.reload('9c1296c0', component.options)
    }
    module.hot.accept("./variant-form.vue?vue&type=template&id=9c1296c0&scoped=true&", function () {
      api.rerender('9c1296c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/product-forms/variant-form.vue"
export default component.exports